module.exports = __webpack_public_path__ + "img/publishing-schedule-icon.971370f2.svg";